import { render } from "./form_3.vue?vue&type=template&id=fe4eb08c"
import script from "./form_3.vue?vue&type=script&lang=js"
export * from "./form_3.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe4eb08c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe4eb08c', __exports__)) {
    console.log('reload')
    api.reload('fe4eb08c', __exports__)
  }
  
  module.hot.accept("./form_3.vue?vue&type=template&id=fe4eb08c", () => {
    console.log('re-render')
    api.rerender('fe4eb08c', render)
  })

}


export default __exports__